import { render } from "./basic-table.vue?vue&type=template&id=7b2ac604&scoped=true"
import script from "./basic-table.vue?vue&type=script&lang=js"
export * from "./basic-table.vue?vue&type=script&lang=js"

import "./basic-table.vue?vue&type=style&index=0&id=7b2ac604&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2ac604"]])

export default __exports__